import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/images/perma_logo.png'


const _hoisted_1 = { class: "flex flex-col items-center sm:flex-row justify-between mx-auto pb-10 max-w-1200px w-full" }
const _hoisted_2 = { class: "flex flex-col items-center mb-8 sm:block sm:mb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-7 opacity-65 mb-3 z-10",
  alt: "permaSwaplogo"
}, null, -1)
const _hoisted_4 = { class: "text-xs font-space-gtotesk-light z-10 opacity-65" }
const _hoisted_5 = { class: "flex flex-row items-center justify-center sm:justify-end z-10" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src"]

interface FooterSrcArr {
  href: string
  src: string
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const footerImgSrc:FooterSrcArr[] = [
  {
    href: 'https://twitter.com/permaswap',
    src: 'twitter.png'
  },
  {
    href: 'https://medium.com/permaswap',
    src: 'medium.png'
  },
  {
    href: 'https://discord.gg/WM5MQZGVPF',
    src: 'discord.png'
  },
  {
    href: 'https://t.me/FinanceEver',
    src: 'telegram.png'
  }
]
const year = new Date().getFullYear()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, " ©" + _toDisplayString(_unref(year)) + " Permaswap. All rights reserved ", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(footerImgSrc, (item, index) => {
        return _createElementVNode("a", {
          key: index,
          href: item.href,
          target: "_blank",
          class: _normalizeClass([index !== footerImgSrc.length-1 ? 'mr-8' : '', "block w-6 h-6 cursor-pointer"])
        }, [
          _createElementVNode("img", {
            src: require(`@/images/${item.src}`),
            class: "block w-6 h-6",
            alt: "footer logo"
          }, null, 8, _hoisted_7)
        ], 10, _hoisted_6)
      }), 64))
    ])
  ]))
}
}

})